import { useWhitelabelFeatures } from 'hooks/whitelabel/useWhitelabelFeatures';

/**
 * Returns whether DaysCarousel should be active.
 * The whitelabel config enables the carousel only when the flag is explicitly true.
 * @returns {boolean} Whether the carousel should be shown.
 */
const useShowDaysCarousel = () => {
  const features = useWhitelabelFeatures();
  const showDaysCarousel = features?.SHOW_DAYS_CAROUSEL;

  return showDaysCarousel === true;
};

export default useShowDaysCarousel;
